import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Grid,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Paper,
    CircularProgress,
    Button,
    Chip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import DownloadIcon from "@mui/icons-material/Download";

const ViewInvoiceOlympiad = ({ closePopup, modalData }) => {

    const [oldData, setOldData] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [historyLoading, setHistoryLoading] = useState(false);

    useEffect(() => {
        getOldData();
    }, []);

    const getOldData = async () => {
        try {

            setHistoryLoading(true);

            const result =
                await window.Platform.database.getGenerateInvoiceDetails({
                    regId: modalData?.regId,
                    partyId: modalData?.partyId,
                });

            if (result?.status) {
                setOldData(result?.data || []);
            } else {
                setOldData([]);
            }

        } catch (error) {

            console.log(error);
            setOldData([]);

        } finally {
            setHistoryLoading(false);
        }
    };

    const downloadFile = async (file) => {
        const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = file.originalName || file.fileName || "download";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error("Download failed:", err);
        }
    };

    return (
        <Box p={3} position="relative">

            {/* HEADER */}

            <Typography
                variant="h5"
                fontWeight={700}
                textAlign="center"
                mb={2}
            >
                View Invoice
                <IconButton
                    onClick={closePopup}
                    sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Typography>

            <Box
                sx={{
                    borderBottom: "1px solid #ddd",
                    position: "relative",
                }}
            >
                <div className="row">
                    <div className="col-md-3">
                        <b>RNO ID:</b> {modalData?.rno_id}
                    </div>
                    <div className="col-md-3">
                        <b>RM Name:</b> {modalData?.userName}
                    </div>

                </div>
                <div className="row mt-1">
                    <div className="col-12">
                        <b>Party Name:</b> {modalData?.schoolName} ({modalData?.partyId})
                    </div>
                </div>
            </Box>


            {historyLoading ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="200px"
                >
                    <CircularProgress />
                </Box>
            ) : oldData?.length > 0 ? (

                oldData.map((item, index) => {

                    return (
                        <Paper
                            key={index}
                            elevation={3}
                            sx={{
                                p: 3,
                                mb: 3,
                                borderRadius: 3,
                                background: "#fff",
                            }}
                        >

                            {/* TOP HEADER */}

                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mb={3}
                                flexWrap="wrap"
                                gap={1}
                            >
                            </Box>

                            {/* INVOICE DETAILS */}

                            <Grid container spacing={2}>

                                <Grid item xs={12} md={4}>
                                    <Typography
                                        fontWeight={600}
                                    >
                                        Invoice Number
                                    </Typography>

                                    <Paper
                                        variant="outlined"
                                        sx={{ p: 1.5 }}
                                    >
                                        {item?.generate_invoice_no || "-"}
                                    </Paper>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography
                                        fontWeight={600}
                                    >
                                        Invoice Amount
                                    </Typography>

                                    <Paper
                                        variant="outlined"
                                        sx={{ p: 1.5 }}
                                    >
                                        ₹ {item?.generate_invoice_amount || "0"}
                                    </Paper>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Typography
                                        fontWeight={600}
                                    >
                                        Invoice Date
                                    </Typography>

                                    <Paper
                                        variant="outlined"
                                        sx={{ p: 1.5 }}
                                    >
                                        {item?.generate_invoice_date
                                            ? item?.generate_invoice_date?.split("T")[0]
                                            : "-"}
                                    </Paper>
                                </Grid>

                            </Grid>

                            {item?.generate_invoice_attachment?.length > 0 && (

                                <Box mt={4}>

                                    <Typography
                                        variant="subtitle1"
                                        fontWeight={700}
                                        mb={1}
                                    >
                                        Attachments
                                    </Typography>

                                    <Grid container spacing={2}>

                                        {item?.generate_invoice_attachment?.map(
                                            (file, fileIndex) => {

                                                const isImage =
                                                    file?.path?.match(
                                                        /\.(jpg|jpeg|png|gif|webp)$/i
                                                    );

                                                return (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={6}
                                                        md={3}
                                                        key={fileIndex}
                                                    >
                                                        <Paper
                                                            elevation={2}
                                                            sx={{
                                                                borderRadius: 3,
                                                                overflow: "hidden",
                                                                p: 1,
                                                                height: "100%",
                                                            }}
                                                        >

                                                            {isImage ? (
                                                                <img
                                                                    src={`${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`}
                                                                    alt={file?.fileName}
                                                                    onClick={() => setPreviewImage(file?.fileName)}
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "160px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "10px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                />
                                                            ) : (

                                                                <Box
                                                                    sx={{
                                                                        height: "160px",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        background: "#f5f5f5",
                                                                        borderRadius: "10px",
                                                                    }}
                                                                >
                                                                    <DescriptionIcon
                                                                        sx={{
                                                                            fontSize: 60,
                                                                            color: "#888",
                                                                        }}
                                                                    />

                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{ mt: 1 }}
                                                                    >
                                                                        File
                                                                    </Typography>
                                                                </Box>
                                                            )}

                                                            {/* FILE NAME */}

                                                            <Typography
                                                                variant="body2"
                                                                mt={1.5}
                                                                textAlign="center"
                                                                sx={{
                                                                    wordBreak: "break-word",
                                                                    minHeight: "40px",
                                                                }}
                                                            >
                                                                {file?.fileName}
                                                            </Typography>

                                                            {/* ACTION */}

                                                            <Box
                                                                display="flex"
                                                                justifyContent="center"
                                                                mt={2}
                                                            >
                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    startIcon={<DownloadIcon />}
                                                                    // href={`${window.Platform.database.funcForBaseURL()}/file/uploads/${file.fileName}`}
                                                                    // target="_blank"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        downloadFile(file);
                                                                    }}
                                                                >
                                                                    Download
                                                                </Button>
                                                            </Box>

                                                        </Paper>
                                                    </Grid>
                                                );
                                            }
                                        )}
                                    </Grid>
                                </Box>
                            )}
                        </Paper>
                    );
                })

            ) : (

                <Paper
                    sx={{
                        p: 5,
                        textAlign: "center",
                        borderRadius: 3,
                    }}
                >
                    <Typography variant="h6">
                        No Invoice Found
                    </Typography>
                </Paper>
            )}

            {/* IMAGE PREVIEW MODAL */}

            {/* <Dialog
                open={!!previewImage}
                onClose={() => setPreviewImage(null)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    Attachment Preview

                    <IconButton
                        onClick={() => setPreviewImage(null)}
                        sx={{
                            position: "absolute",
                            right: 10,
                            top: 10,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>

                    {previewImage && (
                        <img
                            src={previewImage}
                            alt="preview"
                            style={{
                                width: "100%",
                                borderRadius: "10px",
                            }}
                        />
                    )}

                </DialogContent>
            </Dialog> */}
            <Dialog
                open={!!previewImage}
                onClose={() => setPreviewImage(null)}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle>
                    Attachment Preview

                    <IconButton
                        onClick={() => setPreviewImage(null)}
                        sx={{
                            position: "absolute",
                            right: 10,
                            top: 10,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#f5f5f5",
                        minHeight: "400px",
                    }}
                >{console.log(previewImage, "previewImagepreviewImage")}
                    {previewImage && (
                        <img
                            src={`${window.Platform.database.funcForBaseURL()}/file/uploads/${previewImage}`}
                            alt="preview"
                            style={{
                                maxWidth: "100%",
                                maxHeight: "80vh",
                                objectFit: "contain",
                                borderRadius: "10px",
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default ViewInvoiceOlympiad;